<div class="border-bottom pb-4 pt-4 mb-2">
  <div class="d-flex align-items-center mb-2">
    <tr-icon [icon]="icon.stripeLogo" [size]="size.extraLarge" classes="mr-3"></tr-icon>
    <h2 class="m-0">Stripe Connect</h2>
  </div>

  <div class="w-100 pl-5">
    <p>Connect your Stripe account to accept payments for online bookings. Once Stripe is connected, you will see a new option in your Services settings to collect a payment for a booking. The amount collected will be the Price you enter.</p>
    <p>Collected payments will be noted on the customer. You will be responsible for managing these payments (e.g., refunds, applying deposits to bills, etc.).</p>
    <p>TablesReady will deduct a non-refundable {{ serviceFee }}% fee in addition to the Stripe fees.</p>
  </div>

  <div *ngIf="errorMessage" class="w-100 pl-5">
    <ngb-alert [dismissible]="false" type="warning" class="text-center shmalert">
      <div class="d-flex flex-row justify-content-center align-items-center">
        <p class="text-black" [innerText]="errorMessage"></p>
      </div>
    </ngb-alert>
  </div>

  <div class="w-100 pl-5" *ngIf="!connected">
    <button
      class="btn btn-info"
      [disabled]="disabled || sending"
      (click)="authorize()"
    >Connect</button>
  </div>

  <form *ngIf="form && connected" [formGroup]="form" class="pl-5">
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="stripe-payments-enabled" class="col-form-label">Enable</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input
              id="stripe-payments-enabled"
              class="form-check-input"
              type="checkbox"
              name="enabled"
              formControlName="enabled"
            >Enable
          </label>
        </div>
      </div>
    </div>

    <button
      class="btn btn-success"
      style="width: 89px;"
      (click)="save()"
      [disabled]="form.invalid || sending || form.pristine"
    >Save</button>
  </form>
</div>
